import {useParams} from 'react-router-dom';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetParticipationQuery} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import {useGetSaleVehicleQuery} from '@dms/api/vehicle';
import {featureFlags} from '@dms/feature-flags';
import {usePermissions} from '@dms/shared';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function VehicleSourceSubSection() {
  const {id: vehicleId} = useParams();

  const {data: vehicleParticipation} = useGetParticipationQuery(
    {
      resourceId: EntityResourceIds.vehicle,
      recordId: vehicleId ?? '',
    },
    {skip: isNilOrEmpty(vehicleId)}
  );

  const {data: saleVehicle} = useGetSaleVehicleQuery(
    {vehicleId: vehicleId ?? ''},
    {skip: isNilOrEmpty(vehicleId)}
  );

  const [canReadAdvertisingSettings] = usePermissions({
    permissionKeys: ['readAdvertisingSettings'],
    scopes: {
      readAdvertisingSettings: {
        participation: vehicleParticipation,
        branchId: saleVehicle?.branchId,
      },
    },
  });

  return (
    <VFKit.SubSection data-testid="vehicle-source">
      <VFKit.Group data-testid="source-select" columns={[1, 2, 4]}>
        <VFKit.SourceSelect />
        <VFKit.ShowWhen
          when={canReadAdvertisingSettings}
          whenFeatureEnabled={featureFlags.SALES_SALE_PROGRAMS}
        >
          <VFKit.Suspense>
            <VFKit.SalePresetSelect />
          </VFKit.Suspense>
        </VFKit.ShowWhen>
      </VFKit.Group>
    </VFKit.SubSection>
  );
}
